var r={};export{r as phonenumberfield};
//# sourceMappingURL=phoneNumberField.js.map
